var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"popover",style:(_vm.dimensions)},[_vm._t("default"),_vm._v(" "),(_vm.isArrowNeeded)?_c('div',{staticClass:"popover__arrow-up",style:(_vm.arrowPosition)}):_vm._e()],2),_vm._v(" "),_c('p4a-backdrop',{attrs:{"isBackgroundRequired":_vm.isBackgroundRequired},on:{"close":_vm.close}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-212c408c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/ui-kit/components/Popover.vue
// module id = null
// module chunks = 